import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmationModalComponent } from './confirmation-modal.component';
import { FrontendModalModule } from '@tablesready/frontend-modal';

@NgModule({
  imports: [CommonModule, NgbModalModule, FrontendModalModule],
  declarations: [ConfirmationModalComponent],
})
export class ConfirmationModule {}
